<template>
  <div class="row h-100 no-gutters">
    <div class="auth-form mx-auto my-auto col-md-5 col-lg-3">
      <div class="card">
        <div class="card-body">
          <h1 style="text-align: center">
            <img
              id="main-logo"
              class="d-inline-block align-top me-1"
              style="max-width: 100px;"
              src="@/assets/images/logo.jpg"
              alt="" />
          </h1>
          <d-alert
            v-if="authError"
            theme="danger"
            show>
            Błąd autoryzacji. Spróbuj ponownie
          </d-alert>

          <h4 class="text-center mt-4 mb-4">
            Zaloguj się
          </h4>

          <Form ref="loginForm" @submit="login">
            <Field
              name="email"
              rules="required|email"
              v-model="email"
              v-slot="{ field, errorMessage }">
              <div class="form-group">
                <label class="d-flex">
                  Adres e-mail:
                </label>
                <input
                  v-bind="field"
                  type="email"
                  class="form-control"
                  :class="{ 'is-invalid': errorMessage }"
                  placeholder="Twój adres e-mail" />
                <div v-if="errorMessage" class="invalid-feedback">
                  {{ errorMessage }}
                </div>
              </div>
            </Field>

            <Field
              name="password"
              rules="required"
              v-model="password"
              v-slot="{ field, errorMessage }">
              <div class="form-group">
                <label class="d-flex">
                  Hasło:

                  <small class="ms-auto pt-1">
                    <router-link to="/password/reset" tabindex="-1">
                      Nie pamiętasz hasła?
                    </router-link>
                  </small>
                </label>
                <input
                  v-bind="field"
                  type="password"
                  autocomplete="off"
                  class="form-control"
                  :class="{ 'is-invalid': errorMessage }"
                  placeholder="********" />
                <div v-if="errorMessage" class="invalid-feedback">
                  {{ errorMessage }}
                </div>
              </div>
            </Field>

            <d-button
              pill
              type="submit"
              class="mx-auto mt-4 d-block"
              :disabled="submitting">
              <template v-if="!submitting">Zaloguj</template>
              <template v-else>Logowanie&hellip;</template>
            </d-button>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Form, Field } from 'vee-validate';

export default {
  name: 'Login',
  components: {
    Form,
    Field
  },
  data () {
    return {
      authError: false,
      submitting: false,
      email: '',
      password: ''
    }
  },
  methods: {
    login () {
      this.authError = false;
      this.submitting = true;

      this.$http.post('/api/login', {
        email: this.email,
        password: this.password
      }).then((response) => {
        this.submitting = false;
        window.localStorage.setItem('token', response.data.access_token);
        this.$http.defaults.headers.Authorization = `Bearer ${response.data.access_token}`;
        this.$root.userIsLoggedIn = true;

        this.$http.post('/system/users/item/me').then(responseData => {
          this.$store.commit('user/setUser', responseData.data.data);

          this.$nextTick(() => {
            this.$router.push('/products');
          });
        }).catch(error => {
          this.$root.userIsLoggedIn = false;
        });
      }).catch((error) => {
        this.$root.userIsLoggedIn = false;
        this.submitting = false;
        this.authError = true;
      });
    }
  }
}
</script>

<style scoped>

</style>
